// Search schedule (2026-10-28): an event matches when the text is in its
// title OR in the name of a place it visits — so "Teramachi" also finds an
// event called "Morning walk" that goes there. places: the guide's Places
// (getPlace) or a plain list. Kept identical in andiamo-web and andiamo-places.

// getPlace first (fast), then the list by ID as text — a number ID would
// never be === the text in event.Places.
const placeName = (places, id) => {
  if (!places) return "";
  const hit = typeof places.getPlace === "function" ? places.getPlace(id) : null;
  if (hit) return hit.Name || "";
  const list = Array.isArray(places) ? places : places.placesList || [];
  return list.find((p) => p && String(p.ID) === String(id))?.Name || "";
};

export function eventMatchesSearch(event, text, places) {
  const q = String(text || "").trim().toUpperCase();
  if (!q) return true;
  if (String(event?.Subject || "").toUpperCase().includes(q)) return true;
  return String(event?.Places || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .some((id) => placeName(places, id).toUpperCase().includes(q));
}
